(function () {
  if (window.__ssCartPromotionThemeFallbackLoaded) return;
  window.__ssCartPromotionThemeFallbackLoaded = true;

  var fallbackSelector = "[data-ss-cart-promotion-fallback]";

  function runFallback() {
    var source = document.querySelector(fallbackSelector);
    if (!source) return;

    var container = document.getElementById("silksilky-cart-promotion-embed");
    if (!container) {
      container = document.createElement("div");
      container.id = "silksilky-cart-promotion-embed";
      container.style.display = "none";
      document.body.appendChild(container);
    }

    copyProtocolDataset(source, container);
    syncProtocolMounts(container);
    ensureGroupsMount(container);
    loadRuntime(container.dataset.runtimeUrl || source.dataset.runtimeUrl);
  }

  function syncProtocolMounts(source) {
    document
      .querySelectorAll("[data-ss-cart-promotion-mount]")
      .forEach(function (mount) {
        copyProtocolDataset(source, mount);
      });
  }

  function ensureGroupsMount(source) {
    var existingGroupsMount = document.querySelector(
      '[data-ss-cart-promotion-mount][data-kind="groups"]',
    );
    if (existingGroupsMount) {
      copyProtocolDataset(source, existingGroupsMount);
      return;
    }

    var anchor = findCartItemsAnchor();
    if (!anchor) return;

    var mount = document.createElement("div");
    mount.className =
      "ss-cart-promotion-mount ss-cart-promotion-mount--groups tab-cart minicart-tabs-content active";
    mount.hidden = true;
    mount.setAttribute("data-ss-cart-promotion-mount", "");
    mount.dataset.kind = "groups";
    copyProtocolDataset(source, mount);

    if (anchor.insertMode === "prepend") {
      anchor.element.insertBefore(mount, anchor.element.firstChild);
      return;
    }
    anchor.element.parentNode.insertBefore(mount, anchor.element);
  }

  function findCartItemsAnchor() {
    var containerSelectors = [
      "#minicart .items",
      ".minicart-body .items",
      ".minicart__products",
      "[data-cart-items]",
      "cart-items",
      "#CartDrawer-CartItems",
      ".drawer__cart-items-wrapper",
      ".cart-items",
    ];
    var itemSelectors = [".cart-item", ".minicart__product"];

    for (var index = 0; index < containerSelectors.length; index += 1) {
      var container = document.querySelector(containerSelectors[index]);
      if (container) return { element: container, insertMode: "prepend" };
    }

    for (var itemIndex = 0; itemIndex < itemSelectors.length; itemIndex += 1) {
      var item = document.querySelector(itemSelectors[itemIndex]);
      if (item && item.parentNode)
        return { element: item, insertMode: "before" };
    }

    return null;
  }

  function copyProtocolDataset(source, target) {
    Object.keys(source.dataset).forEach(function (key) {
      if (
        key === "runtimeUrl" ||
        key === "ssCartPromotionFallback" ||
        key === "kind" ||
        key === "ssCartPromotionMount" ||
        source.dataset[key] == null
      )
        return;
      target.dataset[key] = source.dataset[key];
    });
    if (source.dataset.runtimeUrl)
      target.dataset.runtimeUrl = source.dataset.runtimeUrl;
  }

  function loadRuntime(runtimeUrl) {
    if (!runtimeUrl) return;
    if (
      document.querySelector("script[data-silksilky-cart-promotion-runtime]") ||
      document.querySelector('script[src*="cart-promotion-runtime.js"]')
    ) {
      return;
    }

    var script = document.createElement("script");
    script.src = runtimeUrl;
    script.defer = true;
    script.dataset.silksilkyCartPromotionRuntime = "true";
    document.head.appendChild(script);
  }

  function scheduleFallback() {
    window.setTimeout(runFallback, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleFallback);
  } else {
    scheduleFallback();
  }
})();
